// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

import * as Radix from '@radix-ui/react-avatar'
import { cn } from '@/lib/utils/cn'

interface AvatarProps {
  src?: string
  name?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeMap = { sm: 'h-7 w-7 text-xs', md: 'h-8 w-8 text-sm', lg: 'h-10 w-10 text-sm' }

function initials(name?: string): string {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/)
  return parts.length >= 2
    ? `${parts[0]![0]}${parts[parts.length - 1]![0]}`.toUpperCase()
    : name.slice(0, 2).toUpperCase()
}

export function Avatar({ src, name, size = 'md', className }: AvatarProps) {
  return (
    <Radix.Root className={cn('relative inline-flex items-center justify-center overflow-hidden rounded-full select-none avatar-glass', sizeMap[size], className)}>
      <Radix.Image src={src} alt={name} className="h-full w-full object-cover" />
      <Radix.Fallback className="text-brand font-semibold relative z-20">{initials(name)}</Radix.Fallback>
      <span className="avatar-glass-shimmer" aria-hidden="true" />
    </Radix.Root>
  )
}
